import React from "react";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import withStyles from '@mui/styles/withStyles';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import CategoryTab from "./CategoryTab";
import { tabStyles } from "./styles";
import NotStartedTable from "./tables/NotStartedTable";

class UpcomingTab extends React.Component {
  state = {
    value: 0,
  };

  componentDidMount() {
    if (this.props.history.location.search) {
      const params = new URLSearchParams(this.props.history.location.search);
      const timeframe = parseInt(params.get("timeframe"), 10);
      const listType = parseInt(params.get("listType"), 10);
      if (!isNaN(listType) && timeframe === 2) {
        this.setState({
          value: listType,
        });
        this.handleChange('', listType);
      } else {
        this.handleChange('', this.state.value);
      }
    } else {
      this.handleChange('', this.state.value);
    }
    this.props.fetchStats("Upcoming");
  }

  handleChange = (event, value) => {
    // this.props.fetchStats("Upcoming");

    if (value === 0) {
      this.props.fetchTotalJobs();
    } else if (value === 1) {
      this.props.fetchUpcomingUnfilledJobs();
    } else if (value === 2) {
      this.props.fetchUpcomingFilledJobs();
    }

    if (this.props.history.location.search) {
      const params = new URLSearchParams(this.props.history.location.search);
      params.set("timeframe", 2);
      params.set("listType", value);
      this.props.history.push(`/jobs/overview?${params.toString()}`);
    }

    this.setState({ value });
  };

  render() {
    const { classes, unfilledTableProps, filledTableProps, totalTableProps } = this.props;

    const tabClass = {
      root: classes.tabRoot,
      selected: classes.tabSelected,
    };
    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            classes={{ indicator: classes.tabIndicator }}>
            <Tab
              label={
                <CategoryTab
                  title="Total"
                  headerClass={classes.tabHeader}
                  labelClass={classes.tabLabel}
                  {...this.props.total}
                />
              }
              classes={tabClass}
            />
            <Tab
              label={
                <CategoryTab
                  title="Unfilled"
                  headerClass={classes.tabHeader}
                  labelClass={classes.tabLabel}
                  {...this.props.unfilled}
                />
              }
              classes={tabClass}
            />
            <Tab
              label={
                <CategoryTab
                  title="Filled"
                  headerClass={classes.tabHeader}
                  labelClass={classes.tabLabel}
                  {...this.props.filled}
                />
              }
              classes={tabClass}
            />
          </Tabs>
        </div>
        <div className={classes.contentContainer}>
          <SwipeableViews axis="x" index={this.state.value} onChangeIndex={this.handleChangeIndex}>
            <NotStartedTable {...totalTableProps} />
            <NotStartedTable {...unfilledTableProps} />
            <NotStartedTable {...filledTableProps} />
          </SwipeableViews>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = state => {
  const totalTableProps = {
    ...JobSelectors.getUpcomingTotalPaginationData(state),
    data: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "total",
      part: "data",
    }),
    pageFilter: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "total",
      part: "filter",
    }),
    pageSort: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "total",
      part: "sort",
    }),
  };

  const unfilledTableProps = {
    ...JobSelectors.getUpcomingUnfilledPaginationData(state),
    data: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "unfilled",
      part: "data",
    }),
    pageFilter: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "unfilled",
      part: "filter",
    }),
    pageSort: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "unfilled",
      part: "sort",
    }),
  };

  const filledTableProps = {
    ...JobSelectors.getUpcomingFilledPaginationData(state),
    data: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "filled",
      part: "data",
    }),
    pageFilter: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "filled",
      part: "filter",
    }),
    pageSort: JobSelectors.getListData(state, {
      timeframe: "upcoming",
      status: "filled",
      part: "sort",
    }),
  };

  return {
    unfilledTableProps,
    filledTableProps,
    totalTableProps,
    ...JobSelectors.getListStats(state, "upcoming"),
  };
};

const mapActions = {
  fetchStats: JobActions.fetchListStats,
  fetchTotalJobs: JobActions.fetchUpcomingTotalJobs,
  onPageChangeTotal: JobActions.fetchUpcomingTotalJobs,
  onSortedChangeTotal: JobActions.setUpcomingTotalSort,
  onFilteredChangeTotal: JobActions.setUpcomingTotalFilter,
  onPageSizeChangeTotal: JobActions.setUpcomingTotalPageSize,
  fetchUpcomingUnfilledJobs: JobActions.fetchUpcomingUnfilledJobs,
  fetchUpcomingFilledJobs: JobActions.fetchUpcomingFilledJobs,
  fetchJobsUnfilled: JobActions.fetchUpcomingUnfilledJobs,
  onPageChangeUnfilled: JobActions.fetchUpcomingUnfilledJobs,
  onSortedChangeUnfilled: JobActions.setUpcomingUnfilledSort,
  onFilteredChangeUnfilled: JobActions.setUpcomingUnfilledFilter,
  onPageSizeChangeUnfilled: JobActions.setUpcomingUnfilledPageSize,
  fetchJobsFilled: JobActions.fetchUpcomingFilledJobs,
  onPageChangeFilled: JobActions.fetchUpcomingFilledJobs,
  onSortedChangeFilled: JobActions.setUpcomingFilledSort,
  onFilteredChangeFilled: JobActions.setUpcomingFilledFilter,
  onPageSizeChangeFilled: JobActions.setUpcomingFilledPageSize,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { unfilledTableProps, filledTableProps, totalTableProps } = stateProps;
  const {
    fetchTotalJobs,
    onPageChangeTotal,
    onSortedChangeTotal,
    onFilteredChangeTotal,
    onPageSizeChangeTotal,
    fetchJobsUnfilled,
    onPageChangeUnfilled,
    onSortedChangeUnfilled,
    onFilteredChangeUnfilled,
    onPageSizeChangeUnfilled,
    fetchJobsFilled,
    onPageChangeFilled,
    onSortedChangeFilled,
    onFilteredChangeFilled,
    onPageSizeChangeFilled,
  } = dispatchProps;
  return {
    ...stateProps,
    ...dispatchProps,

    totalTableProps: {
      ...totalTableProps,
      fetchData: fetchTotalJobs,
      onPageChange: onPageChangeTotal,
      onSortedChange: onSortedChangeTotal,
      onFilteredChange: onFilteredChangeTotal,
      onPageSizeChange: onPageSizeChangeTotal,
    },
    unfilledTableProps: {
      ...unfilledTableProps,
      fetchData: fetchJobsUnfilled,
      onPageChange: onPageChangeUnfilled,
      onSortedChange: onSortedChangeUnfilled,
      onFilteredChange: onFilteredChangeUnfilled,
      onPageSizeChange: onPageSizeChangeUnfilled,
    },
    filledTableProps: {
      ...filledTableProps,
      fetchData: fetchJobsFilled,
      onPageChange: onPageChangeFilled,
      onSortedChange: onSortedChangeFilled,
      onFilteredChange: onFilteredChangeFilled,
      onPageSizeChange: onPageSizeChangeFilled,
    },
    ...ownProps,
  };
};

export default connect(mapState, mapActions, mergeProps)(withStyles(tabStyles)(UpcomingTab));
